import s from './VotePanel.module.css';
import PropTypes from 'prop-types';
import { Like } from 'components/iconComponent/Like';
import { DisLike } from 'components/iconComponent/DisLike';
import { FavoritesIcon } from 'components/iconComponent/FavoritesIcon';

const VotePanel = ({ onVote }) => {
  const onClick = e => {
    onVote(e.currentTarget.name);
  };
  return (
    <div className={s.panel}>
      <button className={s.button__like} onClick={onClick} name="Likes">
        <Like color={'#fff'} width={30} height={30} />
      </button>

      <button
        className={s.button__favourites}
        name="Favorites"
        onClick={onClick}
      >
        <FavoritesIcon width={30} height={30} color={'#fff'} />
      </button>

      <button className={s.button__dislike} name="Dislikes" onClick={onClick}>
        <DisLike color={'#fff'} width={30} height={30} />
      </button>
    </div>
  );
};
export { VotePanel };

VotePanel.propTypes = {
  onVote: PropTypes.func.isRequired,
};
